import axios from 'axios';
import { notify } from 'reapop';

export const SCAN_TOKEN_REQUEST = 'SCAN_TOKEN_REQUEST';
export const SCAN_TOKEN_SUCCESS = 'SCAN_TOKEN_SUCCESS';
export const SCAN_TOKEN_ERROR = 'SCAN_TOKEN_ERROR';

export function scanToken(image) {
    return (dispatch) => {
        dispatch({
            type: SCAN_TOKEN_REQUEST
        });

        // Prepare request
        const formData = new FormData();
        formData.append('image', image);
        formData.append('_method', 'PUT');

        console.log(image);

        return axios.post('http://localhost:8080/AR', formData)
            .then(response => {
                console.log(response["data"][0]["slug"]);
                tokenSlug = response["data"][0]["slug"];
                return dispatch({
                    type: SCAN_TOKEN_SUCCESS,
                    response
                });
            })
            .catch(err => {
                dispatch(notify({
                    message: 'Er ging iets mis bij het scannen van de foto.',
                    dismissible: true,
                    status: 'error',
                    position: 'tc'
                }));
                return dispatch({
                    type: SCAN_TOKEN_ERROR
                });
            });
    };
}
